import * as React from 'react';
import { IEventTeacherItem } from '../../../../../Models/Event/IEventTeacherItem';
import { IUpdateEventTeacher } from '../../../../../Models/Event/IUpdateEventTeacher';
import { TeacherPropertiesView } from './EditTeacherPropertiesView';
import * as Services from '../../../../../Services/Services';
import { useBoolean } from '@fluentui/react-hooks';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';
import { MessageBarType } from '@fluentui/react';

interface IEditTeacherPropertiesProps {
    eventId: number;
    refresh: (eventId: number) => void;
    onDismiss: () => void;
    isOpened: boolean;
    teacher?: IEventTeacherItem;
}


export const EditTeacherProperties: React.FunctionComponent<IEditTeacherPropertiesProps> = (props) => {
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();
    const [teacher, setTeacher] = React.useState<IUpdateEventTeacher>()

    React.useEffect(() => {
        if (props.teacher) {
            setTeacher({
                eventId: props.teacher.eventId,
                mainTeacher: props.teacher.mainTeacher,
                payment: props.teacher.payment,
                id: props.teacher.id
            });
        }
        else {
            setTeacher(undefined);
        }

    }, [props.teacher])

    const propertyChanged = (key: string, value: any) => {
        if (teacher) {
            setTeacher({ ...teacher, [key]: value });
        }
    }

    const save = async (eventId: number, teacher?: IUpdateEventTeacher) => {
        if (teacher) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
            const eventType = await eventTypeApi.updateEventTeacher(eventId, teacher)
            if (eventType.isSuccess && eventType.data) {
                await props.refresh(eventId);
                props.onDismiss();
            }
            else {
                setStatusMessage({ message: eventType.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    }

    return (<TeacherPropertiesView
        isOpened={props.isOpened}
        onDismiss={props.onDismiss}
        eventId={props.eventId}
        teacherName={props.teacher?.firstname + " " + props.teacher?.lastname}
        propertyChanged={propertyChanged}
        teacher={teacher}
        save={save}
        statusMessage={statusMessage}
    />)
}
